import ChatFrame from '@components/chat/ChatFrame'

/**
 * Desktop docked chat — lives inside the activity panel. Mounted once (so it
 * preloads in the background); the activity panel toggles `visible` as the Chat
 * tab is selected, so switching tabs never drops the chat socket.
 */
const Chat = ({ visible = false }) => <ChatFrame docked visible={visible} />

export default Chat
